import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import FormText from '../formText'
import { cn } from 'shared/util/cn'

const Input = forwardRef(
  ({ type = 'text', id, className = '', placeholder = '', disabled, isError, control, name, validation, showError = true, ...rest }, ref) => {
    const classes = cn('field-input', disabled && 'cursor-not-allowed opacity-60', isError && 'border-danger', className)

    if (control) {
      return (
        <Controller
          control={control}
          name={name}
          rules={validation}
          render={({ field, fieldState: { error } }) => (
            <>
              <input
                id={id}
                type={type}
                placeholder={placeholder}
                className={cn(classes, error && 'border-danger')}
                disabled={disabled}
                {...field}
                value={field.value || ''}
                {...rest}
                onBlur={(e) => {
                  e.target.value = e.target.value.trim()
                  field.onBlur(e)
                  field.onChange(e)
                }}
              />
              {showError && error && <FormText>{error?.message}</FormText>}
            </>
          )}
        />
      )
    }

    return <input id={id} type={type} ref={ref} placeholder={placeholder} className={classes} disabled={disabled} {...rest} />
  }
)

Input.displayName = 'Input'
Input.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  isError: PropTypes.bool,
  className: PropTypes.string,
  control: PropTypes.object,
  name: PropTypes.string,
  validation: PropTypes.object,
  showError: PropTypes.bool
}

export default Input
